export default () => {
  document.querySelectorAll(".js-site-header").forEach((el) => {
    const observer = new IntersectionObserver(
      (entries) => {
        // fully intersects with screen
        if (entries[0].intersectionRatio === 0) {
          el.classList.add("site-header--sticky");
        } else {
          el.classList.remove("site-header--sticky");
        }
      },
      { threshold: [0, 1] },
    );

    observer.observe(document.querySelector(".js-site-header-trigger"));
  });
};
